import deleteScheduledActionRedux from 'Modules/scheduledActions/views/components/deleteScheduledAction/redux/reducer';
import editScheduledActionRedux from 'Modules/scheduledActions/views/components/editScheduledAction/redux/reducer';
//export redux objects
export default {
	deleteScheduledActionRedux,
	editScheduledActionRedux,
};